import { render, staticRenderFns } from "./InviteMemberPlanSlideOver.vue?vue&type=template&id=489ce4d2"
import script from "./InviteMemberPlanSlideOver.vue?vue&type=script&lang=js"
export * from "./InviteMemberPlanSlideOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports